module.exports = __webpack_public_path__ + "img/minus.bbf9b624.png";